import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomizedurationComponent } from './pages/customizeduration/customizeduration.component';
import { CustomizeinterestsComponent } from './pages/customizeinterests/customizeinterests.component';
import { CustomizemonthComponent } from './pages/customizemonth/customizemonth.component';
import { CustomizesearchbarComponent } from './pages/customizesearchbar/customizesearchbar.component';
import { CustomizeuroComponent } from './pages/customizeuro/customizeuro.component';
import { CustomizeviewComponent } from './pages/customizeview/customizeview.component';
import { HomeComponent } from './pages/home/home.component';
import { UploadImagesComponent } from './pages/upload-images/upload-images.component';
import { VedioComponent } from './pages/vedio/vedio.component';

const routes: Routes = [

  {path:'home',component:HomeComponent},
  {path:'customizesearchbar',component:CustomizesearchbarComponent},
  {path:'customizeuro',component:CustomizeuroComponent},
  {path:'customizemonth',component:CustomizemonthComponent},
  {path:'customizedur',component:CustomizedurationComponent},
  {path:'customizeinter',component:CustomizeinterestsComponent},
  {path:'customizeview',component:CustomizeviewComponent},
  {path:'vedio',component:VedioComponent},
  {path:'uploadimages',component:UploadImagesComponent}
 

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
